import { motion } from "framer-motion";
import { Clock, Users, BookOpenCheck, Star, Apple, Bus, Languages } from "lucide-react";

const features = [
  {
    icon: Clock,
    title: "24-Hour Care",
    desc: "Reliable childcare around the clock to fit every family's schedule, day or night.",
    color: "sky",
    span: "lg:col-span-2",
  },
  {
    icon: Users,
    title: "Small Ratio Sizes",
    desc: "Fewer children per caregiver means more attention and care for your little one.",
    color: "rose",
    span: "",
  },
  {
    icon: BookOpenCheck,
    title: "Brightwheel Curriculum",
    desc: "A modern, engaging curriculum that keeps you connected to your child's day.",
    color: "amber",
    span: "",
  },
  {
    icon: Star,
    title: "Step Up to Quality Rated",
    desc: "Recognized for meeting Ohio's high standards in early learning quality.",
    color: "emerald",
    span: "",
  },
  {
    icon: Languages,
    title: "Spanish & ASL",
    desc: "Children learn beginner Spanish and American Sign Language through songs, signs, and play.",
    color: "sky",
    span: "",
  },
  {
    icon: Apple,
    title: "Healthy Food Program",
    desc: "Participating in the Healthy Food program for nutritious, balanced meals & snacks.",
    color: "rose",
    span: "",
  },
  {
    icon: Bus,
    title: "Limited Transportation",
    desc: "Convenient transportation available to help families with pickup and drop-off.",
    color: "sky",
    span: "lg:col-span-2",
  },
];

const colorMap = {
  sky: "bg-sky-50 text-sky-500",
  rose: "bg-rose-50 text-rose-500",
  amber: "bg-amber-50 text-amber-500",
  emerald: "bg-emerald-50 text-emerald-500",
};

export default function Programs() {
  return (
    <section id="programs" className="py-20 md:py-28 px-5 md:px-10 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto"
        >
          <span className="text-sm font-semibold tracking-wider uppercase text-sky-500">
            Our Program
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">
            Everything your child needs to flourish
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Caring for children ages 6 weeks to 12 years with the programs and support
            that give families peace of mind.
          </p>
        </motion.div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <motion.div
              key={i}
              data-testid={`program-card-${i}`}
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
              className={`group bg-[#FDFAF5] rounded-2xl p-8 border border-slate-100 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 ${f.span}`}
            >
              <span
                className={`flex items-center justify-center w-14 h-14 rounded-2xl ${colorMap[f.color]} group-hover:scale-110 transition-transform`}
              >
                <f.icon className="w-7 h-7" />
              </span>
              <h3 className="mt-5 text-xl font-bold text-slate-900">{f.title}</h3>
              <p className="mt-2 text-slate-600 leading-relaxed">{f.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
